var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-user"},[_c('div',{staticClass:"user-organistaion"},[_vm._v(" "+_vm._s(_vm.username)+" ")]),_c('div',{staticClass:"settings ml-3 logout"},[_c('b-button',{attrs:{"size":"sm","variant":"outline-brand"},on:{"click":_vm.logout}},[_vm._v(" Sair ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }